import * as React from "react";
import type { OccupancyBuilding } from "./occupancyStatistics";
import { OccupancyOverviewFloor } from "./OccupancyOverviewFloor";
import { OccupancySummary } from "./OccupancySummary";

interface OccupancyOverviewBuildingProps {
  building: OccupancyBuilding;
}

export const OccupancyOverviewBuilding: React.FC<OccupancyOverviewBuildingProps> = ({ building }) => (
  <details className="occupancy-overview__building">
    <summary className="stats-sidebar__btn stats-sidebar__btn--children occupancy-overview__row">
      <span className="occupancy-overview__name">
        <strong>{building.name}</strong>
        <span className="occupancy-overview__city">{building.city}</span>
      </span>
      <OccupancySummary totals={building.totals} />
    </summary>
    {building.floors.length === 0 ? (
      <p className="occupancy-overview__empty">No floors available.</p>
    ) : (
      <ul className="occupancy-overview__floors">
        {building.floors.map((floor) => (
          <OccupancyOverviewFloor key={floor.id} floor={floor} />
        ))}
      </ul>
    )}
  </details>
);
